import service from '@/utils/request'
import qs from 'qs'

export function saveQuoteRequest(quoteRequestData){
  return service({
    url: '/Request/SaveQuoteRequest',
    method: 'post',
    //data: qs.stringify(quoteRequestData, { indices: true }),
    //data:JSON.stringify(quoteRequestData)
    data:quoteRequestData,
  })
}


export function getQuoteRequestBySearchData(requestID,requestCode,Verno) {
  return service({
    url: '/Request/GetQuoteRequestBySearchData',
    method: 'get',
    params: {"RequestID":requestID,"RequestCode":requestCode,"Verno":Verno},
  })
}


export function newQuoteRequest() {
    return service({
      url: '/Request/NewQuoteRequest',
      method: 'get',
      params: { }
    })
}


export function getCustomerList(userId,userName,keywords) {
  return service({
    url: '/Request/GetCustomerList',
    method: 'get',
    params: {"userId":userId,"userName":userName,"keywords":keywords},
  })
}

export function getCurrencyList() {
  return service({
    url: '/Request/GetCurrencyList',
    method: 'get',
    params: { },
  })
}

/** 字典 */
export function GetCodeset_dl(codetype,companyid) {
  return service({
    url: '/Codeset/Get',
    method: 'get',
    params: { "codetype":codetype,"companyid":companyid},
  })
}

/** 模块字典 */
export function GetModuleDict(codetype,companyid) {
  return service({
    url: '/Codeset/GetModuleDict',
    method: 'get',
    params: { "codetype":codetype,"companyid":companyid},
  })
}

export function GetProcessMat(processno) {
  return service({
    url: '/ProcessMat/Get',
    method: 'get',
    params: { "processno":processno},
  })
}

export function GetGsmList(processNo) {
  return service({
    url: '/ProcessMat/GetGsmList',
    method: 'get',
    params: { "processNo":processNo},
  })
}

export function GetKindList(processNo) {
  return service({
    url: '/ProcessMat/GetKindList',
    method: 'get',
    params: { "processNo":processNo},
  })
}

export function GetCountry(location) {
  return service({
    url: '/Request/GetCountry',
    method: 'get',
    params: { "location":location},
  })
}
export function GetCity(location,country) {
  return service({
    url: '/Request/GetCity',
    method: 'get',
    params: { "location":location,"country":country},
  })
}
export function GetTown(location,country,city) {
  return service({
    url: '/Request/GetTown',
    method: 'get',
    params: { "location":location,"country":country,"city":city},
  })
}

export function GetProcessPrice(processno) {
  return service({
    url: '/ProcessMat/GetProcessPrice',
    method: 'get',
    params: { "processno":processno},
  })
}

export function GetQuoteInvtPriceList(processno){
  return service({
    url: '/ProcessMat/GetQuoteInvtPriceList',
    method: 'get',
    params: { "processno":processno},
  })
}

export function GetProcess(processtype) {
  return service({
    url: '/ProcessMat/GetProcess',
    method: 'get',
    params: { "processtype":processtype},
  })
}
export function Get_C_PaperQualityInfo(query) {
  return service({
    url: '/Request/Get_C_PaperQualityInfo',
    method: 'get',
    params: { "query":query},
  })
} 
export function Get_C_Carton() {
  return service({
    url: '/Request/Get_C_Carton',
    method: 'get',
   
  })
} 
export function GetUserRights(param) {
  return service({
    url: '/Request/GetUserRights',
    method: 'post',
    params: param,   
  })
} 
export function AutoLogin(sessionid,signature,system,db) {
  return service({
    url: '/Request/AutoLogin',
    method: 'get',
    params: { "sessionid":sessionid,"signature":signature,"system":system,"db":db},
  })
} 

export function Get_ProdCategoryList(param)
{
  return service({
    url: '/Request/Get_ProdCategoryList',
    method: 'get',
    params: param,
  })
}

export function getCartonOpenSize(paramInfo){
  return service({
    url: '/Request/GetCartonOpenSize',
    method: 'post',
    data:paramInfo,
  })
}

export function GetCustomerAddress(custno) {
  return service({
    url: '/CustomerAddress/Get',
    method: 'get',
    params: { "custno":custno},
  })
}

export function getStartLocationList(custno,ProcessCode) {
  return service({
    url: '/CustomerAddress/GetStartLocationList',
    method: 'get',
    params: { "custno":custno,"ProcessCode":ProcessCode},
  })
}

export function getEstimateReportDetailModel(estimateNo){
  return service({
    url: '/Request/GetEstimateReportDetailModel',
    method: 'get',
    params: { "estimateNo":estimateNo},
  })
}

export function getAnalyzeQuote(companyID,CategoryCode){
  return service({
    url: '/Request/Get_AnalyzeQuote',
    method: 'get',
    params: { "companyID":companyID,"CategoryCode":CategoryCode},
  })
}


export function getNoticeUserHistory(ownerID,customerID,CategoryCode){
  return service({
    url: '/Request/GetNoticeUserHistory',
    method: 'get',
    params: { "ownerID":ownerID,"customerID":customerID,"CategoryCode":CategoryCode},
  })
}






export async function sendQiYeWeiXin(RequestCode){
  return await service({
    url: '/Request/SendQiYeWeiXin',
    method: 'get',
    params: { "RequestCode":RequestCode},
  })
}

export async function SendBacksendQiYeWeiXin(RequestCode){
  return await service({
    url: '/Request/SendBackSendQiYeWeiXin',
    method: 'get',
    params: { "RequestCode":RequestCode},
  })
}

export function PaperSealDegreeList(cate_code,companyID,ItemBrand,gsm,MaterialTypeCode) {
  return service({
    url: '/Request/PaperSealDegreeList',
    method: 'get',
    params: { "cate_code":cate_code,"companyID":companyID,"ItemBrand":ItemBrand,"gsm":gsm,"MaterialTypeCode":MaterialTypeCode},
  })
}

export function GetDept(companyID,typeS) {
  return service({
    url: '/Request/GetDept',
    method: 'get',
    params: { "companyID":companyID,"typeS":typeS},
  })
}

export function GetTransportType(companyID) {
  return service({
    url: '/Request/GetTransportType',
    method: 'get',
    params: { "companyID":companyID},
  })
}
export function GetFobLocList(companyID,ProcessCode) {
  return service({
    url: '/Request/GetFobLocList',
    method: 'get',
    params: { "companyID":companyID,"ProcessCode":ProcessCode},
  })
}

export function GetPackingArrange2D(param)
{
  return service({
    url: '/Request/GetPackingArrange2D',
    method: 'get',
    params: param,
  })
}


//格式化小数点
export function Formatted_Number(NumberS,blxsw,sswl)
{
  if(!isNaN(NumberS)&&NumberS!=''&&NumberS!=null){
    if(sswl){
      NumberS=parseFloat(NumberS).toFixed(blxsw);
    }
    switch (blxsw){
      case 0:{
        return Math.floor(parseFloat(NumberS));
        break;
      }
      case 1:{
        return Math.floor(parseFloat(NumberS)*10)/10;
        break;
      }
      case 2:{
        return Math.floor(parseFloat(NumberS)*100)/100;
        break;
      }
      case 3:{
        return Math.floor(parseFloat(NumberS)*1000)/1000;
        break;
      }
      case 4:{
        return Math.floor(parseFloat(NumberS)*10000)/10000;
        break;
      }
      case 5:{
        return Math.floor(parseFloat(NumberS)*100000)/100000;
        break;
      }
      case 6:{
        return Math.floor(parseFloat(NumberS)*1000000)/1000000;
        break;
      }default:{
        return 0;
        break;
      }
    }    
  }else{
    return '';
  }
}

//格式化小数点为0.125的倍数
export function Formatted_Number_125(NumberS,sswl)
{
  if(!isNaN(NumberS)&&NumberS!=''&&NumberS!=null){
    NumberS=Formatted_Number(NumberS,3,sswl)
    var NumberSArray=NumberS.toString().split('.');
    if(NumberSArray.length==2){
      var NumberS2=Math.floor(parseFloat('0.'+NumberSArray[1])/0.125)*0.125;
      NumberS=parseFloat(NumberSArray[0])+parseFloat(NumberS2);
    }                      
    return NumberS;        
  }else{
    return '';
  }
}

export function GetCartonSize(companyID,ProcessCode) {
  return service({
    url: '/Request/GetCartonSize',
    method: 'get',
    params: { "companyID":companyID,"ProcessCode":ProcessCode},
  })
}


export function PostLocalquote(process_material){
  return service({
    url: '/Request/PostLocalquote',
    method: 'post',
    //data: qs.stringify(quoteRequestData, { indices: true }),
    //data:JSON.stringify(quoteRequestData)
    data:process_material,
  })
}

//两个数比较获取对应值
export function Number_Compare(Number1,Number2,typeS)
{
  var ReturnNumber=Number1;
  if(typeS.toLowerCase()=='max'){
    if(Number2>Number1){
      ReturnNumber=Number2;
    }
  }else{
    if(Number2<Number1){
      ReturnNumber=Number2;
    }
  }
  return ReturnNumber;
}

export function GetNewMaterialState(companyID,MaterialNO) {
  return service({
    url: '/Request/GetNewMaterialState',
    method: 'get',
    params: { "companyID":companyID,"MaterialNO":MaterialNO},
  })
}

export function GetBoxOpenSize(companyID,TypeCode, SizeLength, SizeWidth, SizeHeight,PartCode, SpecialSize,A,N) {
  return service({
    url: '/Request/GetBoxOpenSize',
    method: 'get',
    params: { "companyID":companyID,"TypeCode":TypeCode,"SizeLength":SizeLength,"SizeWidth":SizeWidth,"SizeHeight":SizeHeight,"PartCode":PartCode,"SpecialSize":SpecialSize,"A":A,"N":N},
  })
}

export function GetQuoteEstimateQty(companyID,EstimateNo) {
  return service({
    url: '/Request/GetQuoteEstimateQty',
    method: 'get',
    params: { "companyID":companyID,"EstimateNo":EstimateNo},
  })
}


export function GetEfficiencyState(companyID,EfficiencyNO) {
  return service({
    url: '/Request/GetEfficiencyState',
    method: 'get',
    params: { "companyID":companyID,"EfficiencyNO":EfficiencyNO},
  })
}

export function CheckProductFormula(companyID,TypeCode) {
  return service({
    url: '/Request/CheckProductFormula',
    method: 'get',
    params: { "companyID":companyID,"TypeCode":TypeCode},
  })
}

export function CheckEstimateStatus(companyID,EstimateNo) {
  return service({
    url: '/Request/CheckEstimateStatus',
    method: 'get',
    params: { "companyID":companyID,"EstimateNo":EstimateNo},
  })
}

export function GetCompanyList(IsTest) {
  return service({
    url: '/Request/GetCompanyList',
    method: 'get',
    params: { "IsTest":IsTest},
  })
}

export function GetCustomerQuoteRequest(customerCode, systemVersion, keywords, companyID) {
  return service({
    url: '/Request/GetCustomerQuoteRequest',
    method: 'get',
    params: { "customerCode":customerCode,"systemVersion":systemVersion,"keywords":keywords,"companyID":companyID},
  })
}


export function GetQualityRequirements(customerCode, companyID){
  return service({
    url: '/Request/GetQualityRequirements',
    method: 'get',
    params: { "customerCode":customerCode,"companyID":companyID},
  })
}

export function GetSubCompanyList() {
  return service({
    url: '/Request/GetSubCompanyList',
    method: 'get'
  })
}

export function GetBomInfo(paramInfo){
  return service({
    url: '/Request/GetBomInfo',
    method: 'post',
    data:paramInfo,
  })
}

export function GetOpportunitiesList(paramInfo){
  return service({
    url: '/Request/GetOpportunitiesList',
    method: 'post',
    data:paramInfo,
  })
}

export function GetQuoteReturnRecordList(paramInfo){
  return service({
    url: '/QuoteRequest/GetQuoteReturnRecordList',
    method: 'post',
    data:paramInfo,
  })
}



// WEBPACK FOOTER //
// ./src/api/quoteRequest.js